<template>
  <div class="orphaned-reports">
    <h2>Orphaned Reports</h2>
    <div v-if="loading">
      <UiProgressCircular v-if="loading" />
    </div>
    <div v-else-if="error" class="error">
      {{ error }}
    </div>
    <table v-if="!loading && orphans" class="orphan-table" border="0" cellspacing="0">
      <thead>
          <th>Id</th><th>Time</th><th>Location</th>
      </thead>
      <tbody>
        <tr v-for="orphan in orphans" :key="orphan.id">
          <td>{{ orphan.id }}</td>
          <td>{{ orphan.time }} ({{ timeAgo(orphan.time) }})</td>
          <td>
            <a
              v-if="orphan.lat && orphan.lon"
              target="_blank"
              :href="`https://www.google.com/maps/search/?api=1&query=${orphan.lat},${orphan.lon}`"
            >{{ orphan.lat }}, {{ orphan.lon }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment';
import { UiProgressCircular } from 'keen-ui';
import { fetchOrphanedReports } from '@/store/modules/api';


export default {
  name: 'OrphanedReports',
  data() {
    return {
      loading: null,
      orphans: null,
      error: null,
    };
  },
  mounted() {
    this.fetchOrphans();
  },
  methods: {
    async fetchOrphans() {
      this.loading = true;
      this.error = null;
      try {
        const { orphans } = await fetchOrphanedReports();
        this.orphans = orphans;
      } catch (e) {
        this.error = e;
      }
      this.loading = false;
    },
    timeAgo(ts) {
      return moment(ts).fromNow();
    },
  },
  components: { UiProgressCircular },
};
</script>

<style lang="scss" scoped>
.error {
  color: red;
}
.orphan-table {
  width: fit-content;
  margin: 40px auto 0 auto;
  tr, th {
    padding: 10px 50px;
    height: 30px;
  }
  tr:nth-child(even) {
    background-color: #f2f2f2;
  }
}
.ui-progress-circular {
  margin: 40px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/OrphanedReports.vue